import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Card, List as AntList, Icon } from "antd";
import { RadialScore } from "components";
import { OrderedMap, Map } from "immutable";
import { PermissionContextManager } from "hocs";
// import { formatCurrency } from "utilities/index";
// import SalesAnalysisTradeYear from "./sales-analysis-trade-year";
// import BankStatementAnalysisTab from "./bank-statement-analysis-tab";
// import DocumentComplianceSummary from "./document-compliance-summary";
// import FinancialAnalysisRatios from "./financial-analysis-ratios";
// import TransactionAnalysisSummary from "./transaction-analysis-summary";
// import AnalysisSummaryView from "./analysis-summary-view";
// import moment from "moment";

import { Table } from "components/table";
import { STATE_STATUS } from "../../constants";
// const { TabPane } = Tabs;

// const CIBIL_DETAILS = new OrderedMap({
//     name: {
//         title: "Name",
//         key: "name",
//         dataIndex:"name"
//     },
//     cibil_score: {
//         title: "CIBIL Score",
//         key: "cibil_score",
//         dataIndex: "cibil_score"
//     },
//     cibil_remarks: {
//         title: "Remarks",
//         key: "cibil_remarks",
//         dataIndex: "cibil_remarks"
//     },
//     cibil_report: {
//         title: "CIBIL Report",
//         key: "cibil_report",
//         dataIndex: "cibil_report"
//     },
//     cibil_supported_report: {
//         title: "CIBIL Supporting Documents",
//         key: "cibil_supported_report",
//         dataIndex: "cibil_supported_report"
//     }
// });

const ListItem = AntList.Item;
const ListItemMeta = AntList.Item.Meta;

const COMPANY_SUMMARY_LIST = new OrderedMap({
    associates: {
        label: "Name",
        title: "Name",
        key: "name",
        dataIndex: "name",
        value: ["John Mayer", "John Adams"].join(" | ")
    },
    email: {
        label: "Email",
        title: "Email",
        key: "email",
        dataIndex: "email",
        value: "john.adams@gmail.com"
    },
    phone: {
        label: "Phone",
        title: "Phone",
        key: "phone",
        dataIndex: "phone",
        value: "+91-9811299292"
    },
    business_address: {
        label: "Business Address",
        title: "Business Address",
        key: "business_address",
        dataIndex: "business_address",
        value: "Some Address",
        render: _ => {
            return (
                _.address_line_1 +
                " " +
                _.address_line_2 +
                ", " +
                _.city.name +
                ", " +
                _.state.name +
                ", " +
                _.pincode
            );
        }
    }
});

// const BANK_QUESTIONNARE_LIST = new OrderedMap({
//     // business_vintage_with_anchor: {
//     //     label: "Business Vintage with anchor 1 year",
//     //     value: "Yes"
//     // },
//     // business_dependency: {
//     //     label: "Business dependency with anchor 1 year",
//     //     value: "No"
//     // },
//     business_vintage: {
//         label: "Business Vintage",
//         value: "Yes"
//     },
//     shop_ownership: {
//         label: "Property Ownership",
//         value: "Yes"
//     },
//     age: {
//         label: "Age of Borrower",
//         value: "No"
//     }
// });

// const PROGCAP_SCORE_CARD_LIST = (company, caseDetail) =>
//     new OrderedMap({
//         cibil: {
//             label: "Relationship vintage with  Corporate (in months)",
//             value: caseDetail.business_vintage
//         },
//         avg_bank_balance: {
//             label: `Level of Engagement:
//                     - Frequency of sales
//                     - Repayments`,
//             value: caseDetail.level_of_engagement
//         },
//         cheque_bounces: {
//             label: "Dependence",
//             value: caseDetail.dependence
//         },
//         vintage_with_anchor: {
//             label: "Promptness of Payment",
//             value: caseDetail.promptness_payment
//         },
//         // dependence_on_anchor: {
//         //     label: "Dependence on Anchor",
//         //     value: "No"
//         // },
//         level_of_engagement: {
//             label: "Bureau checks",
//             value: company.high_cibil
//         },
//         // promptness_of_payment: {
//         //     label: "Promptness of Payment",
//         //     value: "No"
//         // },
//         business_vintage: {
//             label: "Property Ownership",
//             value: company.property_ownership
//         },
//         age: {
//             label: "Age of main Borrower",
//             value: company.main_borrower_age
//         }
//     });

// const FINANCIAL_SCORECARD_LIST = new OrderedMap({
//     cibil: {
//         label: "CIBIL",
//         value: "No"
//     },
//     avg_bank_balance: {
//         label: "Average Bank Balance",
//         value: "No"
//     },
//     cheque_bounces: {
//         label: "Cheque Bounces",
//         value: "No"
//     },
//     vintage_with_anchor: {
//         label: "Vintage with Anchor",
//         value: "No"
//     },
//     // dependence_on_anchor: {
//     //     label: "Dependence on Anchor",
//     //     value: "No"
//     // },
//     level_of_engagement: {
//         label: "Level of Engagement",
//         value: "No"
//     },
//     promptness_of_payment: {
//         label: "Promptness of Payment",
//         value: "No"
//     },
//     business_vintage: {
//         label: "Business Vintage",
//         value: "Yes"
//     },
//     shop_ownership: {
//         label: "Property Ownership",
//         value: "No"
//     },
//     age: {
//         label: "Age of Borrower",
//         value: "No"
//     }
// });

const CompanySummaryList = ({ company }) => {
    return (
        <Table
            columns={COMPANY_SUMMARY_LIST}
            data={company.associates
                .map(_ => {
                    _.business_address = company.addresses.find(
                        __ => __.associate === _.id
                    );
                    return _;
                })
                .toList()}
            pagination={true}
            showTopSection={false}
            keyFilter={"id"}
        />
    );
    // company.associates
    //     .map(_ => (
    //         <Descriptions className={"p-5"} key={_.id} bordered>
    //             {COMPANY_SUMMARY_LIST.map((__, k) => {
    //                 if (k === "associates") {
    //                     __.value = _.first_name + " " + _.last_name;
    //                 }
    //                 if (k === "business_address") {
    //                     let val = company.addresses
    //                         .toList()
    //                         .find(val => val.associate === _.id) || {
    //                         address_line_1: null
    //                     };
    //                     __.value =
    //                         val.address_line_1 +
    //                         " " +
    //                         val.address_line_2 +
    //                         ", " +
    //                         val.city.name +
    //                         ", " +
    //                         val.state.name +
    //                         ", " +
    //                         val.pincode;
    //                 }
    //                 if (k === "phone") {
    //                     __.value = _.phone;
    //                 }
    //                 if (k === "email") {
    //                     __.value = _.email;
    //                 }
    //                 return (
    //                     <Descriptions.Item key={__.label} label={__.label}>
    //                         {__.value}
    //                     </Descriptions.Item>
    //                 );
    //             })
    //                 .toList()
    //                 .toArray()}
    //         </Descriptions>
    //     ))
    //     .toList()
    //     .toArray();
};

CompanySummaryList.propTypes = {
    company: PropTypes.object
};

let score_details=null;
class CreditScoreCard extends React.Component {

    componentDidUpdate(prevProps) {
        if (prevProps.scorecard.getIn([2,'status']) == STATE_STATUS.FETCHING &&  this.props.scorecard.getIn([2,'status']) == STATE_STATUS.FETCHED) {
            this.updateParent();
        }
    }

    updateParent = () => {
        score_details = new Map(
            this.props.scorecard &&
                this.props.scorecard.getIn([2, "data", "details"])
        )
            .map(({ label, value }) => {
                if (["Level of Engagement", "Dependence", "Promptness of Payment"].includes(label)) {
                    return {
                        key: 0,
                        label,
                        value: (
                            <Icon
                                type="check-circle"
                                theme="filled"
                                style={{ color: "#87d068", fontSize: "19px" }}
                            />
                        )
                    };
                }
                if (
                    label === "Relationship Vintage with Corporate (in months)" || 
                    label === "Relationship Vintage with  Corporate (in months)"
                ) {
                    return {
                        key: 3,
                        label: "Vintage with Corporate",
                        value: this.props.caseDetail.business_vintage
                    };
                }
                if (label === "Age of the main Borrower(in years)") {
                    return {
                        key: 4,
                        label: "Age of the main Borrower",
                        value: value ? `${value}yrs` : this.props.company.main_borrower_age
                    };
                }
                if (label === "Bureau Checks") {
                    return {
                        key: 5,
                        label: "Bureau Check",
                        value: (value && value.max) || this.props.company.high_cibil || this.props.caseDetail.loan_track || -1
                    };
                }
                if (label === "Property Ownership") {
                    return {
                        key: 6,
                        label,
                        value: this.props.company.property_ownership
                    };
                }
            })
            .filter(_ => _ && _.label !== "Level of Engagement")
            .set("level_of_engagement", {
                key: 0,
                label: "Level of Engagement",
                value: (
                    <Icon
                        type="check-circle"
                        theme="filled"
                        style={{ color: "#87d068", fontSize: "19px" }}
                    />
                )
            })
            .toList()
            .push({
                key: 7,
                label: "Shop Vintage",
                value: (this.props.caseDetail && this.props.caseDetail.business_vintage_self) || "-- months"
            })
            .sort((x, y) => (x.key - y.key));

        this.props.updateScoreDetails(score_details);
    };

    render() {
        // let sum_of_bank_stmt =
        //     this.props.statements &&
        //     this.props.activeBankAccountKey &&
        //     this.props.statements.getIn([
        //         this.props.activeBankAccountKey,
        //         "data"
        //     ]) &&
        //     this.props.statements
        //         .getIn([this.props.activeBankAccountKey, "data"])
        //         .toList()
        //         .reduce((agg, _) => agg + +_.total_balance, 0);
        const { company, caseDetail } = this.props;
        if (!company) {
            return "FETCHING";
        }
        const finalScore = new Map(
            this.props.scorecard &&
                this.props.scorecard.getIn([2, "data", "score"])
        );

        // const bureau_checks = this.props.scorecard && this.props.scorecard.getIn([2, "data", "details"]) && this.props.scorecard.getIn([2, "data", "details"]).find(_ => _.label === "Bureau Checks");

        // let banking_scores = new Map(
        //     this.props.scorecard &&
        //         this.props.scorecard.getIn([2, "data", "score"])
        // );
        //     .map((value, key) => {
        //     if (key === "Business") {
        //         return value;
        //     }
        //     return (
        //         (this.props.scorecard
        //             .getIn([1, "data", "groups"])
        //             .find(_ => _.label === key).weight *
        //             value) /
        //         this.props.scorecard
        //             .getIn([1, "data", "groups"])
        //             .map(_ => _.weight)
        //             .reduce((_, agg) => _ + agg, 0)
        //     );
        // });

        // let score_details = new Map(
        //     this.props.scorecard &&
        //         this.props.scorecard.getIn([2, "data", "details"])
        // )
        //     .map(({ label, value }) => {
        //         if (label === "Level of Engagement") {
        //             return {
        //                 key: 0,
        //                 label,
        //                 value: (
        //                     <Icon
        //                         type="check-circle"
        //                         theme="filled"
        //                         style={{
        //                             color: "#87d068",
        //                             fontSize: "19px"
        //                         }}
        //                     />
        //                 )
        //             };
        //         }
        //         if (label === "Dependence") {
        //             return {
        //                 key: 1,
        //                 label,
        //                 value: (
        //                     <Icon
        //                         type="check-circle"
        //                         theme="filled"
        //                         style={{
        //                             color: "#87d068",
        //                             fontSize: "19px"
        //                         }}
        //                     />
        //                 )
        //             };
        //         }
        //         if (label === "Promptness of Payment") {
        //             return {
        //                 key: 2,
        //                 label,
        //                 value: (
        //                     <Icon
        //                         type="check-circle"
        //                         theme="filled"
        //                         style={{
        //                             color: "#87d068",
        //                             fontSize: "19px"
        //                         }}
        //                     />
        //                 )
        //             };
        //         }
        //         if (
        //             label === "Relationship Vintage with Corporate (in months)" || label === "Relationship Vintage with  Corporate (in months)"
        //         ) {
        //             return {
        //                 key: 3,
        //                 label: "Vintage with Corporate",
        //                 value: caseDetail.business_vintage
        //             };
        //         }
        //         if (label === "Age of the main Borrower(in years)") {
        //             return {
        //                 key: 4,
        //                 label: "Age of the main Borrower",
        //                 value: value ? `${value}yrs` : company.main_borrower_age
        //             };
        //         }

        //         if (label === "Bureau Checks") {
        //             return {
        //                 key: 5,
        //                 label: "Bureau Check",
        //                 value: (value && value.max) || company.high_cibil || caseDetail.loan_track || -1
        //             };
        //         }
        //         if (label === "Property Ownership") {
        //             return {
        //                 key: 6,
        //                 label,
        //                 value: company.property_ownership
        //             };
        //         }
        //     })
        //     .filter(_ => _ && _.label !== "Level of Engagement")
        //     .set("level_of_engagement", {
        //         key: 0,
        //         label: "Level of Engagement",
        //         value: (
        //             <Icon
        //                 type="check-circle"
        //                 theme="filled"
        //                 style={{
        //                     color: "#87d068",
        //                     fontSize: "19px"
        //                 }}
        //             />
        //         )
        //     })
        //     .toList()
        //     .push({
        //         key: 7,
        //         label: "Shop Vintage",
        //         value: (this.props.caseDetail && this.props.caseDetail.business_vintage_self) ||  "-- months"
        //     })
        //     .sort((x, y) => {
        //         let a = null,
        //             b = null;
        //         if (x) {
        //             a = x.key;
        //         }
        //         if (y) {
        //             b = y.key;
        //         }
        //         if (a < b) {
        //             return -1;
        //         }
        //         if (a > b) {
        //             return 1;
        //         }
        //         if (a === b) {
        //             return 0;
        //         }
        //     });
        return (
            <Col span={7} className={"p-10"}>
                <Card className={"padless-card p-5"} style={{
                    height: "600px"
                }}>
                    <Row className={"d-flex justify-content-center"}>
                        <Col
                            className={
                                "p-5 d-flex flex-column align-items-center"
                            }
                        >
                            <RadialScore
                                value={finalScore.get("Progcap-Fi")}
                                maxBound={1000}
                                render={(percent, { value, maxBound }) =>
                                    `${value}/${maxBound}`
                                }
                                label={"Progcap-FI Score"}
                            />
                            <AntList
                                size={"small"}
                                style={{ minwidth: "300px" }}
                            >
                                {score_details && score_details.size && score_details
                                    .map(_ => (
                                        <ListItem key={_.label}>
                                            <ListItemMeta title={_.label} />
                                            <div>{_.value}</div>
                                        </ListItem>
                                    ))
                                    .toList()
                                    .toArray()}
                            </AntList>
                        </Col>
                    </Row>
                </Card>
            </Col>
        );
    }
}

CreditScoreCard.propTypes = {
    scorecard: PropTypes.object,
    company: PropTypes.object,
    caseDetail: PropTypes.object,
    supplyChain: PropTypes.object,
    balance: PropTypes.number,
    statements: PropTypes.object,
    limit: PropTypes.number,

    stageId: PropTypes.number,
    caseId: PropTypes.number,
    caseTaskId: PropTypes.number,
    companyId: PropTypes.number,
    financials: PropTypes.object, // SupplyChainFinancials Data
    financialsStatus: PropTypes.string, //
    scorecardStatus: PropTypes.string,
    proposed_limit: PropTypes.number,
    fetchCaseSupplyChainFinancials: PropTypes.func,
    fetchScoreCard: PropTypes.func,
    fetchStatement: PropTypes.func,
    checklist: PropTypes.object,
    documents: PropTypes.object,
    fetchDocumentsChecklist: PropTypes.func,
    fetchCaseDocuments: PropTypes.func,
    getActionModal: PropTypes.func,
    openDocView: PropTypes.func,
    updateCaseDetail: PropTypes.func,
    supplyChainRecord: PropTypes.object,
    supplyChainStatus: PropTypes.string,
    fetchCaseSupplyChainDetails: PropTypes.func,
    approveCase: PropTypes.func,
    referCase: PropTypes.func,
    isRiskApprover: PropTypes.bool,
    activeBankAccountKey: PropTypes.number
};

export default PermissionContextManager({
    permission: "credit_summary_view"
})(CreditScoreCard);
